import { Container, Text, TextInput } from '@loomhq/lens';
import React from 'react';

const SalesforceDeleteEmail = ({ email }) => {
  return (
    <>
      <Text color="bodyDimmed">
        Any engagement will no longer be tracked in Salesforce.
      </Text>
      <Container paddingTop="large" paddingBottom="small">
        <TextInput value={email} isDisabled />
      </Container>
    </>
  );
};

export default SalesforceDeleteEmail;
